import PropTypes from 'prop-types'

import {
  SectionTitle,
  CodeWrapper,
  CodeBlock
} from 'components/common/Codeblock'
import { CopyButton } from 'components/common/CopyButton'
import { OnboardingLink } from 'components/common/OnboardingLink'
import useAuth from 'hooks/use-auth'
import theme from 'theme'

const Helm = ({ colorTheme, ...rest }) => {
  const { currentTeamId } = useAuth()

  const namespaceCode = `helm install gremlin gremlin/gremlin \

--namespace gremlin \

--set gremlin.secret.managed=true \

--set gremlin.secret.type=secret \

--set gremlin.secret.teamID=${currentTeamId} \

--set gremlin.secret.clusterID=$GREMLIN_CLUSTER_ID \

--set gremlin.secret.teamSecret=$GREMLIN_TEAM_SECRET`

  return (
    <CodeWrapper {...rest}>
      <div css={{ paddingBottom: theme.space[2] }}>
        <div css={{ display: 'flex', alignItems: 'flex-end' }}>
          <SectionTitle colorTheme={colorTheme}>
            Let Gremlin know your Gremlin team ID and your Kubernetes cluster
            name:
          </SectionTitle>
          <CopyButton
            colorTheme={colorTheme}
            content={`GREMLIN_TEAM_ID="${currentTeamId}"
GREMLIN_CLUSTER_ID="changeit"`}
          />
        </div>
        <CodeBlock
          code={`GREMLIN_TEAM_ID="${currentTeamId}"
GREMLIN_CLUSTER_ID="changeit"`}
        />
      </div>
      <div css={{ paddingBottom: theme.space[2] }}>
        <div css={{ display: 'flex', alignItems: 'flex-end' }}>
          <SectionTitle colorTheme={colorTheme}>
            Add the Gremlin helm chart:
          </SectionTitle>
          <CopyButton
            colorTheme={colorTheme}
            content="helm repo add gremlin https://helm.gremlin.com"
          />
        </div>
        <CodeBlock code="helm repo add gremlin https://helm.gremlin.com" />
      </div>
      <div css={{ paddingBottom: theme.space[2] }}>
        <div css={{ display: 'flex', alignItems: 'flex-end' }}>
          <SectionTitle colorTheme={colorTheme}>
            Create a namespace for the Gremlin Kubernetes client:
          </SectionTitle>
          <CopyButton
            colorTheme={colorTheme}
            content="kubectl create namespace gremlin"
          />
        </div>
        <CodeBlock code="kubectl create namespace gremlin" />
      </div>
      <div>
        <div css={{ display: 'flex', alignItems: 'flex-end' }}>
          <SectionTitle colorTheme={colorTheme}>
            Create a namespace for the Gremlin Kubernetes client. Find{' '}
            <code>teamSecret</code> in{' '}
            <OnboardingLink
              css={{ textDecoration: 'underline' }}
              target="_blank"
              to={`/settings/team/${currentTeamId}/configuration`}
              type="contrast"
            >
              Team Settings
            </OnboardingLink>
          </SectionTitle>
          <CopyButton colorTheme={colorTheme} content={namespaceCode} />
        </div>
        <CodeBlock code={namespaceCode} />
      </div>
    </CodeWrapper>
  )
}

Helm.propTypes = {
  colorTheme: PropTypes.oneOf(['light', 'dark'])
}

export default Helm
